import getAbsoluteUrl from '../../lib/getAbsoluteUrl';

export default ({ jobs }) => ({
  jobs: jobs.map(job => ({
    ...job,
    company: {
      ...(job.company || {}),
      logoUrl: job.company && getAbsoluteUrl(job.company.logoUrl),
    },
    properties:
      (job.properties || []).map(property =>
        ({ ...property, value: getAbsoluteUrl(property.value) })),
  })),
});
